import { TemplateAPI, type Node, type Shape } from "@livereader/graphly-d3";

export const useIcon = () => {
	return {
		shapeSize: 140,
		shapeBuilder: shapeBuilder,
	};

	function shapeBuilder(data: Node, Template: any) {
		const { Shape, SVGShape, TextCollection, CollectionStyle, ShapeStyle, Alignment, OnZoom, LODStyle } = Template;
		const shape = SVGShape(data.payload?.svg);
		shape.select('path')
			.style('stroke', data.payload?.color ?? '#51ff00')
			.style('fill', 'none');

		shape.classed("gly_teal_fill", false);
		shape.classed("gly-selectable", true);

		const bbox = Shape.getBBox(shape);
		const titleShape = TextCollection(
			data.payload?.title ?? '',
			CollectionStyle(100, bbox.width * 0.8, bbox.width * (data.payload?.x ?? 0.10), bbox.height * (data.payload?.y ?? 0.50), 10, 10, 2, Alignment.Center),
			[ShapeStyle('class', 'gly_text.light'), ShapeStyle('font-size', '4em')]
		);
		shape.append(() => titleShape.node());
    
		OnZoom(data, [0.6], [LODStyle(titleShape, 'class', 'hidden', (k: any) => k < 0.2)]);
		return shape;
	}
};
